import React, { useRef } from 'react';
import emailjs from 'emailjs-com';
import { Button } from 'react-bootstrap';
import '../App'

const Contact = () => {
    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_87kcj0e', 'template_mibf3pm', form.current, 'user_9Lca685DSDkdEUPWi5RGa')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
        e.target.reset();
    };


    return (
        <div id="contact">
            <div className="mx-auto text-center my-5 p-4 contact" style={{ backgroundColor: 'rgb(23, 42, 69' }}>
                <h2>Get In Touch</h2>
                <form ref={form} onSubmit={sendEmail}>

                    <input style={{ borderRadius: '5px' }} className="w-100 p-2 mt-4" placeholder="Your name" type="text" name="user_name" /> <br />

                    <input style={{ borderRadius: '5px' }} className="w-100 p-2 mt-3" placeholder="Your Email" type="email" name="user_email" /> <br />

                    <textarea style={{ borderRadius: '5px', padding: '10px 20px 60px 10px' }} className="w-100 mt-3" placeholder="Your Massage" name="message" /> <br />
                    <input style={{ backgroundColor: '#64ffda', border: 'none', borderRadius: '5px' }} className="w-100 p-2 my-3" type="submit" value="Send" />
                    <p>Sending to <span className="title-color">cseaktarinahstu@gmail.com</span> </p>
                </form>

            </div>
            <div className="text-center pb-3">
                <p>Designed & Developed by <span className="title-color">Aktarina Akhi</span> </p>
                <p><i className="far fa-copyright"></i>2021 All rights reserved aktarina akhi</p>
                <div>
                    <span><i className="fas fa-star"></i> star & froks</span>
                    <a target="_blank" rel="noreferrer" href="https://github.com/aktarinaakhi">
                        <Button className="ms-2 p-0" variant="success" size="sm">By me </Button>

                    </a>

                </div>
            </div>


        </div>
    );
};

export default Contact;